import { render, staticRenderFns } from "./DashboardTemplate.vue?vue&type=template&id=2937c38a&scoped=true"
import script from "./DashboardTemplate.vue?vue&type=script&lang=js"
export * from "./DashboardTemplate.vue?vue&type=script&lang=js"
import style0 from "./DashboardTemplate.vue?vue&type=style&index=0&id=2937c38a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2937c38a",
  null
  
)

export default component.exports